(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('soar-js');

  // Hitmarker on button press
  if (reduce) return;
  document.addEventListener('pointerdown', (event) => {
    const target = event.target.closest('.button, .shopify-payment-button__button, .product-form__input label');
    if (!target) return;
    const mark = document.createElement('span');
    mark.className = 'soar-hitmarker';
    mark.setAttribute('aria-hidden', 'true');
    mark.style.left = `${event.clientX}px`;
    mark.style.top = `${event.clientY}px`;
    document.body.appendChild(mark);
    mark.animate(
      [
        { opacity: 1, transform: 'scale(0.6)' },
        { opacity: 1, transform: 'scale(1)', offset: 0.35 },
        { opacity: 0, transform: 'scale(1.15)' }
      ],
      { duration: 260, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
    ).finished.then(() => mark.remove());
  });
})();
